import React from 'react';
import { Grid, TextField, Box, DialogContent } from '@material-ui/core';
import { paymentMethodService, PaymentMethod, UpdatePaymentMethodModel } from '@lib/state';
import { StyledDialog, FormHub, NameForm, AddressForm, FormSubmitButton } from '@lib/common';

interface Props {
  show: boolean;
  onClose: () => void;
  paymentMethod: PaymentMethod;
}

export const PaymentMethodModal: React.FC<Props> = ({ show, onClose, paymentMethod }) => {
  const submit = (model: UpdatePaymentMethodModel) => {
    if (paymentMethod.authNetPaymentId != null) {
      paymentMethodService.updatePaymentMethod(
        paymentMethod.authNetPaymentId,
        model.name,
        model.address,
        model.defaultMethod
      );
      onClose();
    }
  };

  return (
    <StyledDialog
      title={`Editing Card Ending in ${paymentMethod.cardLastFour}`}
      onClose={onClose}
      open={show}
    >
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={6}>
            <TextField
              value={`•••• •••• •••• ${paymentMethod.cardLastFour}`}
              label="Card Number"
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={3}>
            <TextField
              value={`${paymentMethod.expirationMonth}/${paymentMethod.expirationYear}`}
              label="Exp Date"
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={3}>
            <TextField value={`•••`} label="CVC" fullWidth disabled />
          </Grid>
        </Grid>

        <FormHub onSubmit={submit}>
          <NameForm name={paymentMethod.name} />
          <AddressForm address={paymentMethod.billingAddress} />
          <Box display="flex" justifyContent="flex-end" my={1}>
            <FormSubmitButton size="small" color="secondary" variant="contained">
              Save
            </FormSubmitButton>
          </Box>
        </FormHub>
      </DialogContent>
    </StyledDialog>
  );
};
